var sliderprojects;

function projectsliderSettings(){

	var sliderSettings = {
		infiniteLoop: true,
		pager: false,
		controls: true,
		minSlides: 1,
		maxSlides: 1,
		moveSlides: 1,
	};

	var sliderSettings2 = {
		infiniteLoop: true,
		pager: false,
		controls: true,
		minSlides: 1,
		maxSlides: 1,
		moveSlides: 1,
	};

	return ($(window).width()>991) ? sliderSettings2 : sliderSettings;
}

function projectsliderReload() {
	sliderprojects.reloadSlider(projectsliderSettings());
}

if($('.location-slider-inner').length ){
	sliderprojects = $('.location-slider-inner').bxSlider(projectsliderSettings());

	$(window).resize(function(){
		projectsliderReload();
	});
}


// WEBPACK FOOTER //
// ./scripts/includes/single-locations.js